import { ClassGroup } from 'modules/arena/class-groups/types';
import { Badge } from 'shared/components/ui/Badge';
import { cn } from 'shared/utils/cn';

interface ClassGroupRowProps {
  group: ClassGroup;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export function ClassGroupRow({ group, isSelected, onSelect }: ClassGroupRowProps) {
  const activeStudents = group.students.filter((student) => student.status !== 'cancelada').length;
  const isFull = activeStudents >= group.capacity;

  return (
    <button
      type="button"
      onClick={() => onSelect(group.id)}
      className={cn(
        'flex w-full flex-col gap-1 rounded-xl border p-4 text-left transition-colors',
        isSelected ? 'border-primary bg-accent-soft/30' : 'border-border/40 hover:border-primary'
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-ink">{group.name}</span>
        <Badge tone={group.status === 'ativa' ? 'success' : 'neutral'}>
          {group.status === 'ativa' ? 'Ativa' : 'Pausada'}
        </Badge>
      </div>

      <p className="text-sm text-ink-secondary">
        {group.sport} · {group.instructor}
      </p>
      <p className="text-xs text-ink-secondary">
        {group.court} · {group.scheduleLabel} ({group.durationLabel})
      </p>

      <div className="mt-1 flex items-center justify-between">
        <span className={cn('text-sm font-medium', isFull ? 'text-warning' : 'text-ink')}>
          {activeStudents}/{group.capacity} alunos{isFull ? ' · lotada' : ''}
        </span>
        <span className="text-sm font-medium text-ink">R$ {group.monthlyPrice}/mês</span>
      </div>
    </button>
  );
}
